// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__33BRX","noInteraction":"EventWrapper_noInteraction__1TRA8"};